module.exports = __webpack_public_path__ + "img/387041.d9842e48.svg";